import {Component, Input} from '@angular/core';
import {BrandName} from "@commonShared/models";


@Component({
  selector: 'cl-back-panel',
  templateUrl: './back-panel.component.html',
  styleUrls: ['./back-panel.component.scss']
})
export class BackPanelComponent {

  @Input()
  backLabel = 'Wróć';

  @Input()
  backLink = './';

  protected readonly BrandName = BrandName;
  protected readonly window = window;
}
